import { useLocation } from 'react-router-dom';

function useQueryParams() {
  return Object.fromEntries(new URLSearchParams(useLocation().search));
}

export default useQueryParams;
